import React, { useEffect, useState } from 'react';
import { PillButton } from 'Components/Fields/Buttons';
import { Modal } from 'Components/Modal';
import { getFormattedDate, timestampToDate } from 'Utils/Format';
import { trackPage, trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import './PauseModal.css';

export const PauseModal = ({
  handlePauseSubscription,
  isFetching,
  isShowing,
  nextBillingDateTime,
  onClose,
  activeSubscriptionId,
  activeSubscriptionServiceName,
  currentPlanPrice,
  selectedDuration,
}) => {
  const [pauseDate, setPauseDate] = useState('');
  const [resumeDate, setResumeDate] = useState('');

  useEffect(() => {
    if (selectedDuration && nextBillingDateTime) {
      const date = new Date(nextBillingDateTime);
      date.setDate(date.getDate() + selectedDuration.value);
      setPauseDate(nextBillingDateTime ? timestampToDate(nextBillingDateTime) : '');
      setResumeDate(nextBillingDateTime ? getFormattedDate(date.toString()) : '');
    }
  }, [selectedDuration, nextBillingDateTime]);

  useEffect(() => {
    if (isShowing) {
      trackPage('Account Pause Confirm Modal Landing', window.location.pathname, 'pause_confirm_modal_landing');

      const confirmedStartedData = {
        page_plan_id: activeSubscriptionId,
        page_plan_name: activeSubscriptionServiceName,
        page_plan_price: parseFloat(currentPlanPrice),
        page_plan_pause_length: selectedDuration.text,
        page_start_source: 'settings',
      };
      trackEvent(TRACKING_ENUMS.EVENT_ACCOUNT_PAUSE_CONFIRMED_STARTED, confirmedStartedData, confirmedStartedData);
    }
  }, [isShowing, activeSubscriptionId, activeSubscriptionServiceName, currentPlanPrice, selectedDuration]);

  return (
    <Modal isShowing={isShowing} customClass="pauseModal" hideCloseButton onClose={onClose}>
      <div className="wrapper">
        <div className="header">Your subscription will be paused on {pauseDate}.</div>
        <div className="content">
          <div className="message">
            Your subscription will be paused at the end of your current billing period on {pauseDate} and will resume
            automatically after the pause period on {resumeDate}. Select &quot;OK&quot; to confirm subscription pause.
          </div>
          <PillButton text="OK" onClick={handlePauseSubscription} isDisabled={isFetching} />
          <button type="button" className="maybeText" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};
